<app-navbar title="Godziny" [saveStatus]="saveStatus">
	<button class="btn btn-secondary me-4" (click)="emailGenerate()"><i class="far fa-envelope"></i> e-mail</button>
	<button class="btn btn-secondary me-4" (click)="isTourGenerate()"><i class="fas fa-bus"></i> IsTour</button>
	<button class="btn btn-secondary me-4" (click)="showVehicles = !showVehicles">
		<i class="fas fa-bus"></i> Pojazdy
	</button>
	<a class="btn btn-primary me-4" routerLink="/tourism-transport-list/{{ id }}">
		<i class="fas fa-list"></i> Listy
	</a>
	<a class="btn btn-primary me-4" routerLink="/tourism-map/{{ id }}"> <i class="fas fa-map-marked-alt"></i> Mapa </a>
	<a class="btn btn-warning me-4" routerLink="/timetable/{{ id }}"> <i class="fas fa-radiation"></i> Podstawowe </a>
</app-navbar>
<ol class="breadcrumb">
	<li class="breadcrumb-item fw-bolder">{{ sideName }}</li>
	<li class="breadcrumb-item" *ngFor="let item of seasons">
		{{ item.destinationName }}
		<span *ngIf="side === 'departure'">({{ item.departureDate }} {{ item.accommodationFrom }})</span>
		<span *ngIf="side === 'return'">({{ item.departureFromDestination }} {{ item.arrivalToLastStop }})</span>
	</li>
</ol>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<div class="card">
	<div class="card-body" [innerHTML]="email"></div>
</div>

<table class="table table-striped table-hover table-bordered table-sm" *ngIf="web.length">
	<tbody *ngFor="let seasons of web">
		<tr *ngFor="let item of seasons">
			<td>{{ item?.product }}</td>
			<td>{{ item?.cityName }}</td>
			<td>{{ item?.cityDetail }}</td>
			<td>{{ item?.date }}</td>
			<td>{{ item?.accomodationDate }}</td>
			<td>{{ item?.time }}</td>
		</tr>
	</tbody>
</table>

<table class="table table-striped table-hover table-bordered table-sm" *ngIf="isTour.length">
	<thead>
		<tr>
			<th>Kod miasta</th>
			<th>Czas</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of isTour">
			<td>{{ item.cityCode }}</td>
			<td>{{ item.timeBetween }}</td>
		</tr>
	</tbody>
</table>

<app-tourism-timetable-vehicles
	*ngIf="showVehicles"
	[vehicles]="vehicles"
	[vehiclesAll]="vehiclesAll"
	[(data)]="data"
	(changed)="vehicleChanged()"
></app-tourism-timetable-vehicles>

<table class="table table-striped table-hover table-bordered table-sm align-middle">
	<thead>
		<tr>
			<th>Pojazd</th>
			<th>Miasto</th>
			<th>Pasażerów</th>
			<th>Przerwa</th>
			<th>Godzina odjazdu</th>
			<th>Natężenie</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data; index as index">
			<td>
				<i class="{{ item.vehicleType }}"></i>
				{{ item.vehicle?.name }}
			</td>
			<td>{{ item.city?.name }}</td>
			<td>
				<span *ngIf="item.people.get > 0"><i class="fas fa-user-plus"></i> {{ item.people.get }}</span>
				<span *ngIf="item.people.put > 0"><i class="fas fa-user-minus"></i> {{ item.people.put }}</span>
			</td>
			<td class="smallBox">
				<div class="input-group">
					<input
						type="number"
						class="form-control"
						min="0"
						name="stopTime"
						[(ngModel)]="item.stopTime"
						(change)="hourChanged(item)"
						[disabled]="!item.stopTimeEditable"
					/>
					<span class="input-group-text">min.</span>
				</div>
			</td>
			<td class="smallBox">
				<input
					type="date"
					class="form-control"
					[(ngModel)]="item.date"
					name="date"
					(change)="hourChanged(item)"
					[disabled]="!item.timeEditable"
				/>
				<input
					type="time"
					step="300"
					class="form-control"
					[(ngModel)]="item.time"
					name="time"
					(change)="hourChanged(item)"
					[disabled]="!item.timeEditable"
				/>
			</td>
			<td>
				<select
					class="form-select"
					[(ngModel)]="item.traffic"
					name="traffic"
					(change)="hourChanged(item)"
					[disabled]="item.timeEditable"
				>
					<option value="0">Niskie</option>
					<option value="1">Średnie</option>
					<option value="2">Duże</option>
				</select>
			</td>
		</tr>
	</tbody>
</table>
